import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { skechersAddressEntity } from "../entity/skechers-address-entity";

@Injectable()
export class AddressRepo extends Repository<skechersAddressEntity> {

    constructor(@InjectRepository(skechersAddressEntity) private repo: Repository<skechersAddressEntity>
    ) {
        super(repo.target, repo.manager, repo.queryRunner);
    }
}